<mat-card class="card-aufgaben mb-4" *ngIf="pruefdatenSource">
    <mat-card-header></mat-card-header>
    <mat-card-content>

        <table mat-table [dataSource]="aufgabeDataSource" class="mat-elevation-z1 table-aufgabe">
            <ng-container matColumnDef="{{aufgabeColumn.name}}" *ngFor="let aufgabeColumn of initAufgabeColumns">
                <th mat-header-cell *matHeaderCellDef> {{aufgabeColumn.label.toUpperCase()}}  </th>
                <td mat-cell *matCellDef="let element"> {{element[aufgabeColumn.name]}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedAufgabeColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedAufgabeColumns;" class="aufgabe-row"></tr>
        </table>

        <table mat-table [dataSource]="pruefdatenSource" class="mat-elevation-z8 table-aufgabe">
            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initPruefdatenColumns">
                <th mat-header-cell *matHeaderCellDef>
                    {{column.label.toUpperCase()}}
                </th>
                <td mat-cell *matCellDef="let element">{{element[column.name]}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedPruefdatenColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedPruefdatenColumns"></tr>
        </table>

        <mat-card class="card-stepper mat-elevation-z1">
            <mat-card-content>

                <mat-stepper class="mt-1">
                    <mat-step label="Pr&uuml;fung auf vorhandenen Standort" state="duplicate">
                        <p>Ist der zu pr&uuml;fende Standort bereits vorhanden?</p>
                        <p class="mat-error" *ngIf="this.duplikateDataSource.length === 0">Keine passenden Standorte gefunden.</p>
                        <table *ngIf="this.duplikateDataSource.length > 0" mat-table [dataSource]="duplikateDataSource" class="mat-elevation-z1 alternative-vorschlaege-table">
                            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initDuplikateColumns">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{column.label.toUpperCase()}}
                                </th>
                                <td mat-cell *matCellDef="let element">{{element[column.name]}}</td>
                            </ng-container>

                            <ng-container matColumnDef="selectDuplikatVorschlagCol">
                                <th mat-header-cell *matHeaderCellDef> AUSWAHL </th>
                                <td mat-cell *matCellDef="let data">
                                    <mat-radio-button color="primary" (click)="selectDuplikatVorschlag(data);"
                                                      name="selectDuplikatVorschlag"
                                                      [checked]="data.checked"
                                                      [value]="formDuplikat.get('selectDuplikatVorschlag')?.value">
                                    </mat-radio-button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedDuplikateVorschlaegeColumnsWithSelects"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedDuplikateVorschlaegeColumnsWithSelects"></tr>
                        </table>

                        <p class="mt-4" *ngIf="vorschlaegeFirmenIndexDataSource">Suchergebnis:</p>
                        <table *ngIf="vorschlaegeFirmenIndexDataSource" mat-table [dataSource]="vorschlaegeFirmenIndexDataSource"
                               matSort multiTemplateDataRows (matSortChange)="sortData(vorschlaegeFirmenIndexDataSource)"
                               class="mat-elevation-z1 firmenindex-vorschlaege-table mt-3 mb-4">
                            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initFirmenIndexColumns">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{column.label.toUpperCase()}}
                                </th>
                                <td mat-cell *matCellDef="let element">{{element[column.name]}}</td>
                            </ng-container>

                            <ng-container matColumnDef="selectDuplikatVorschlagCol">
                                <th mat-header-cell *matHeaderCellDef> AUSWAHL </th>
                                <td mat-cell *matCellDef="let data">
                                    <mat-radio-button color="primary" (click)="selectDuplikatVorschlag(data);"
                                                      name="selectDuplikatVorschlag"
                                                      [checked]="data.checked"
                                                      [value]="formDuplikat.get('selectDuplikatVorschlag')?.value">
                                    </mat-radio-button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedFirmenIndexVorschlaegeColumnsWithSelects"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedFirmenIndexVorschlaegeColumnsWithSelects"></tr>
                        </table>

                        <mat-paginator #paginatorFI
                                       [hidden]="firmenIndexResultListLength <= 10"
                                       [length]="firmenIndexResultListLength"
                                       [showFirstLastButtons]="true"
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]">
                        </mat-paginator>

                        <div class="button-wrapper right mt-4">
                            <button [disabled]="!duplicateSelected"
                                    class="btn btn-flat bg-gradient-success mr-3" (click)="selectDuplikatVorschlagAsAufgabenpaket()">
                                Standort ist vorhanden <i class="fas fa-check"></i>
                            </button>
                            <button class="btn btn-flat bg-gradient-primary mr-3" (click)="openFirmenIndexSucheModal()"   >
                                Standort suchen <i class="fas fa-search"></i>
                            </button>
                            <button class="btn btn-flat bg-gradient-secondary" matStepperNext>
                                Weiter zu Schritt 2 <i class="fas fa-arrow-right"></i>
                            </button>
                        </div>
                    </mat-step>

                    <mat-step label="Pr&uuml;fung ESW-Daten" state="esw">
                        <p>Dieser Standort ist noch nicht in der Firmenverwaltung vorhanden.</p>
                        <p>Ist einer dieser Standorte passend?</p>
                        <p class="mat-error" *ngIf="eswSearchResult.length === 0">Keine passenden Standorte in ESW gefunden.</p>

                        <table *ngIf="eswSearchResult.length > 0" mat-table [dataSource]="vorschlaegeESWDataSource"
                               matSort multiTemplateDataRows (matSortChange)="sortData(vorschlaegeESWDataSource)"
                               class="mat-elevation-z1 esw-vorschlaege-table">
                            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initESWVorschlaegeColumns">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{column.label.toUpperCase()}}
                                </th>
                                <td mat-cell *matCellDef="let element">{{element[column.name]}}</td>
                            </ng-container>

                            <ng-container matColumnDef="selectESWVorschlagCol">
                                <th mat-header-cell *matHeaderCellDef> AUSWAHL </th>
                                <td mat-cell *matCellDef="let data">
                                    <mat-radio-button color="primary" (click)="selectESWVorschlag(data);"
                                                      name="selectESWVorschlag"
                                                      [checked]="data.checked"
                                                      [value]="formESW.get('selectESWVorschlag')?.value">
                                    </mat-radio-button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedESWVorschlaegeColumnsWithSelects"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedESWVorschlaegeColumnsWithSelects"></tr>
                        </table>

                        <mat-paginator #paginator
                                       [hidden]="eswSearchResult.length <= 10"
                                       [length]="eswSearchResult.length"
                                       [showFirstLastButtons]="true"
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]">
                        </mat-paginator>

                        <div class="button-wrapper right mt-4">
                            <button [disabled]="!eswSelected"
                                    class="btn btn-flat bg-gradient-success mr-3" (click)="selectESWVorschlagAsAufgabenpaket()">
                                Standort ist passend <i class="fas fa-check"></i>
                            </button>
                            <button class="btn btn-flat bg-gradient-primary mr-3" (click)="openESWSucheModal()"   >
                                ESW-Standort suchen <i class="fas fa-search"></i>
                            </button>
                            <button class="btn btn-flat bg-gradient-secondary" matStepperNext>
                                Weiter zu Schritt 3 <i class="fas fa-arrow-right"></i>
                            </button>
                        </div>
                    </mat-step>

                    <mat-step label="Neuanlage Standort" state="new">
                        <p>Der Standort ist noch nicht in der Firmenverwaltung vorhanden und wird neu angelegt.</p>
                        <p>Folgende Informationen werden gespeichert:</p>

                        <h5>Firma & Hauptstandort</h5>
                        <table mat-table [dataSource]="neuanlageFirmaDataSource" class="mat-elevation-z1 mb-3">
                            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initNeuanlageFirmaColumns">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{column.label.toUpperCase()}}
                                </th>
                                <td mat-cell *matCellDef="let element">{{element[column.name]}}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedNeuanlageFirmaColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedNeuanlageFirmaColumns;"></tr>
                        </table>

                        <ng-container *ngIf=" ! this.pruefdatenSource[0].salesforceId">
                            <h5>PC-Adresse</h5>
                            <table mat-table [dataSource]="neuanlagePcAdresseDataSource" class="mat-elevation-z1">
                                <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initNeuanlagePcAdresseColumns">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{column.label.toUpperCase()}}
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element[column.name]}}</td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedNeuanlagePcAdresseColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedNeuanlagePcAdresseColumns;"></tr>
                            </table>
                        </ng-container>

                        <div class="button-wrapper left mt-4" *ngIf="this.pruefdatenSource[0].salesforceId">
                            <button class="btn btn-flat bg-gradient-danger" (click)="openRejectDialog()">
                                Standort verwerfen <i class="fas fa-trash"></i>
                            </button>
                        </div>
                        <div class="button-wrapper right mt-4">
                            <button *ngIf="this.pruefdatenSource[0].salesforceId"
                                    class="btn btn-flat bg-gradient-primary" (click)="openEditStandortDatenModal()">
                                Standort bearbeiten <i class="fas fa-edit"></i>
                            </button>
                            <button class="btn btn-flat bg-gradient-success ml-3" (click)="markAsResolved('ada')">
                                Standort speichern <i class="fas fa-save"></i>
                            </button>
                        </div>
                    </mat-step>

                    <!-- Icon overrides. -->
                    <ng-template matStepperIcon="duplicate">
                        <mat-icon>content_copy</mat-icon>
                    </ng-template>
                    <ng-template matStepperIcon="esw">
                        <mat-icon>manage_search</mat-icon>
                    </ng-template>
                    <ng-template matStepperIcon="new">
                        <mat-icon>add</mat-icon>
                    </ng-template>
                </mat-stepper>
            </mat-card-content>
        </mat-card>

    </mat-card-content>
</mat-card>

<mat-card class="card-actions back">
    <mat-card-content>
        <button (click)="back()" class="btn btn-flat bg-gradient-secondary left">
            <i class="fas fa-arrow-left"></i> Zur&uuml;ck zur Liste
        </button>
    </mat-card-content>
</mat-card>

<div class="modal fade" id="modalESWSearch" tabindex="-1" role="dialog" aria-labelledby="modalESWSearchLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">Suche in ESW</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="eswSucheForm" class="search-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="eswSuche()">
                    <div class="container">
                        <div class="row">
                            <div class="col-4">
                                <mat-form-field class="input-field" style="width:100%">
                                    <input matInput formControlName="firmenname" placeholder="Firma">
                                </mat-form-field>
                            </div>
                            <div class="col">
                                <mat-form-field class="input-field" style="width:100%">
                                    <input matInput formControlName="strasse" placeholder="Stra&szlig;e">
                                </mat-form-field>
                            </div>
                            <div class="col-1">
                                <mat-form-field class="input-field" style="width:100%">
                                    <input matInput formControlName="plz" placeholder="PLZ">
                                </mat-form-field>
                            </div>
                            <div class="col">
                                <mat-form-field class="input-field" style="width:100%">
                                    <input matInput formControlName="ort" placeholder="Ort">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>
                <p class="small text-center">ESW liefert derzeit max. 50 Ergebnisse.</p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="resetESWSuche()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button class="btn bg-gradient-primary btn-flat pl-4 pr-4" (click)="eswSuche()">
                    Suchen <i class="fa fa-search"></i>
                </button>

            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalFirmenIndexSearch" tabindex="-1" role="dialog" aria-labelledby="modalFirmenIndexSearchLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">Suche in FirmenIndex</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="firmenIndexSucheForm" class="search-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="firmenIndexSuche()">
                    <div class="container">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-firma-input">
                                    <mat-form-field class="input-field" style="width:100%;">
                                        <input matInput formControlName="firma" placeholder="Firma (Firmen-ID, Firmenname, Crefonummer, Firmenstandorte-ID)">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-1">
                                <div class="form-text mx-2">
                                    <p>oder</p>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="form-firmenstandort-input">
                                    <mat-form-field class="input-field" style="width:100%;">
                                        <input matInput formControlName="firmenstandort" placeholder="Postanschrift (Straße, PLZ, Ort, BeDirect-ID)">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="resetFirmenIndexSuche()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button class="btn bg-gradient-primary btn-flat pl-4 pr-4" (click)="firmenIndexSuche()">
                    Suchen <i class="fa fa-search"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalEditStandortDaten" tabindex="-1" role="dialog" aria-labelledby="modalEditStandortDatenLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-gradient-primary">
                <h5 class="modal-title">Standort bearbeiten</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="editStandortDatenForm" class="edit-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="editStandortDaten()">
                    <h5>Firma &amp; Hauptstandort</h5>
                    <div class="row">
                        <div class="col-7">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Firmenname</mat-label>
                                <input matInput formControlName="firmenname">
                            </mat-form-field>
                        </div>
                        <div class="col-5"></div>
                    </div>
                    <div class="row">
                        <div class="col-5">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Straße</mat-label>
                                <input matInput formControlName="strasseUndHausnummer">
                            </mat-form-field>
                        </div>
                        <div class="col-2">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>PLZ</mat-label>
                                <input matInput formControlName="plz">
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Ort</mat-label>
                                <input matInput formControlName="ort">
                            </mat-form-field>
                        </div>
                        <div class="col-2">
                            <mat-form-field appearance="outline" class="responsive_input">
                                <mat-label>Land (Code)</mat-label>
                                <input matInput formControlName="laendercode">
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat bg-gradient-secondary" (click)="closeEditStandortDatenModal()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button class="btn bg-gradient-success btn-flat" (click)="editStandortDaten()"
                        [disabled]="editStandortDatenForm.touched && editStandortDatenForm.status !== 'VALID' || editStandortDatenForm.errors">
                    Standort speichern <i class="fa fa-save"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade show" id="modalSuccess" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content bg-gradient-success-modal">
            <div class="modal-header">
                <h4 class="modal-title">Erfolg!</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p *ngIf="successMsg[0]">
                    {{ successMsg[0] }}
                </p>
                <p *ngIf="successMsg[1]">
                    {{ successMsg[1] }}
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat btn-outline-light" (click)="closeSuccessModal()">
                    <i class="fas fa-arrow-left"></i> Zur&uuml;ck zur Liste
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade show" id="modalError" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content bg-gradient-danger-modal">
            <div class="modal-header">
                <h4 class="modal-title">Fehler!</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p *ngIf="errorMsg[0]">
                    {{ errorMsg[0] }}
                </p>
                <p *ngIf="errorMsg[1]">
                    {{ errorMsg[1] }}
                </p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat btn-outline-light" (click)="closeErrorModal()">
                    <i class="fas fa-arrow-left"></i> Zur&uuml;ck zur Liste
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade show" id="modalReject" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content bg-gradient-danger-modal">
            <div class="modal-header">
                <h4 class="modal-title">Standort verwerfen?</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Sind Sie sicher, dass dieser Standort verworfen werden soll?</p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-flat btn-outline-light" (click)="closeRejectModal()">
                    Abbrechen <i class="fas fa-times"></i>
                </button>
                <button type="button" class="btn btn-flat btn-outline-light" (click)="rejectStandort()">
                    Standort verwerfen <i class="fas fa-trash"></i>
                </button>
            </div>
        </div>
    </div>
</div>
